import { ArrowLeft, Check, Globe2, LockKeyhole, RefreshCw, Share2 } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import type { ConsumerBootstrap } from "../lib/models";
import { useFitPass } from "../lib/useFitPass";

export function FitPassPage({ data }: { data: ConsumerBootstrap }) {
  const navigate = useNavigate();
  const profile = data.bodyProfile;
  const { session, error, loading, refresh } = useFitPass(Boolean(profile));
  const [shared, setShared] = useState(false);
  const [shareError, setShareError] = useState("");

  const share = async () => {
    if (!session) return;
    setShareError("");
    try {
      if (navigator.share) await navigator.share({ title: "Il mio FitYouX Pass", text: "Questa è la mia taglia FitYouX.", url: session.shareUrl });
      else await navigator.clipboard.writeText(session.shareUrl);
      setShared(true);
    } catch (reason) {
      if (reason instanceof DOMException && reason.name === "AbortError") return;
      setShareError("Non siamo riusciti a condividere il pass. Aggiorna il QR e riprova.");
    }
  };

  return <main className="fit-pass-page">
    <header><button aria-label="Indietro" onClick={() => navigate(-1)}><ArrowLeft /></button><strong>FitYouX Pass</strong><span aria-hidden="true" /></header>
    <section>
      <p className="fit-pass-user-label">FitYouX ID</p>
      <h1>{data.user.fitId}</h1>
      <div className="fit-pass-qr-large">
        {session ? <img src={`/api/fit-pass/${encodeURIComponent(session.token)}/qr`} alt="QR temporaneo per condividere le misure FitYouX" /> : <div><LockKeyhole /><span>{loading ? "Prepariamo il pass…" : profile ? "Aggiorna il QR per mostrarlo" : "Crea prima il tuo profilo"}</span></div>}
      </div>
      <h2>Questa è la mia taglia.</h2>{profile?.provider === "demo-estimate" ? <p className="example-notice"><strong>Pass di esempio</strong>Contiene misure fittizie, non le tue.</p> : profile?.reviewStatus !== "approved" ? <p className="review-notice">Misure da verificare con il modellista.</p> : null}
      <p>Il QR apre le misure e le preferenze che scegli di condividere.</p>
      {session ? <div className="fit-pass-ready"><Check />Pronto da mostrare</div> : null}
      <div className="fit-pass-privacy"><LockKeyhole /><p><strong>Mostra il QR solo a chi vuoi autorizzare.</strong><span>Il link permette di leggere le tue misure per 10 minuti, o fino alla scadenza della prova.</span></p></div>
      <div className="fit-pass-unit"><Globe2 /><span>Unità di misura</span><strong>{profile?.measurementSystem ?? "EU"}</strong></div>
      {error ? <p className="form-error" role="alert">{error}</p> : null}
      {shareError ? <p className="form-error" role="alert">{shareError}</p> : null}
      <button className="fit-pass-share" onClick={() => void share()} disabled={!session}><Share2 />{shared ? "Pass condiviso" : "Condividi il pass"}</button>
      <button className="fit-pass-refresh" onClick={() => void refresh()} disabled={!profile || loading}><RefreshCw />Aggiorna il QR</button>
      {!profile ? <button className="fit-pass-share" onClick={() => navigate("/app/scan")}>Crea il mio profilo</button> : null}
      <button className="fit-pass-close" onClick={() => navigate("/app")}>Chiudi</button>
      <details><summary>Come funziona</summary><p>La boutique scansiona il pass e legge le misure del tuo profilo e le preferenze salvate. Il suo team le confronta con il cartamodello del brand. Ogni nuovo QR crea un link valido per dieci minuti.</p></details>
    </section>
  </main>;
}
